import React from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import { colors } from '../../constants/styleConstants';

const DeleteFbIcon = ({ color, className }) => <DeleteIcon className={className} style={{ fill: color }} />;

DeleteFbIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

DeleteFbIcon.defaultProps = {
  color: colors.red,
  className: '',
};

export default DeleteFbIcon;
